import { Link, useNavigate } from '@tanstack/react-router';
import { useLogout } from '../../services/cloudflare';
import { cn } from '../ui/lib/utils';

export function LayoutRightSideNav() {
  const logoutMutation = useLogout();
  const navigate = useNavigate();
  const handleLogout = async () => {
    await logoutMutation.mutateAsync();
    navigate({ to: '/' });
  };
  return (
    <>
      <nav className="space-x-6">
        {' '}
        <Link
          to="/namespaces"
          className={cn(
            'transition-colors text-muted-foreground hover:text-primary',
            'data-[active]:text-primary data-[active]:font-medium',
          )}
          activeProps={{ 'data-active': true }}
        >
          Namespaces
        </Link>
        <Link
          to="/keys"
          className={cn(
            'transition-colors text-muted-foreground hover:text-primary',
            'data-[active]:text-primary data-[active]:font-medium',
          )}
          activeProps={{ 'data-active': true }}
        >
          Browse Keys
        </Link>
        <button
          type="button"
          onClick={handleLogout}
          className="text-red-400 hover:text-red-300 transition-colors cursor-pointer"
        >
          Logout
        </button>
      </nav>
    </>
  );
}
